// ============================================================
// БУРГЕР МЕНЮ
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  const burger = document.querySelector('.site-header__burger');
  const nav = document.querySelector('.site-header__nav');

  // Создаём оверлей
  const overlay = document.createElement('div');
  overlay.className = 'site-header__overlay';
  document.body.appendChild(overlay);

  function toggleMenu() {
    burger.classList.toggle('active');
    nav.classList.toggle('open');
    overlay.classList.toggle('active');
    document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
  }

  if (burger) {
    burger.addEventListener('click', toggleMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', toggleMenu);
  }

  // Закрываем меню при клике на ссылку
  document.querySelectorAll('.site-header__nav-link').forEach(link => {
    link.addEventListener('click', () => {
      if (nav && nav.classList.contains('open')) {
        toggleMenu();
      }
    });
  });
});

// ============================================================
// ФИКСИРОВАННАЯ ШАПКА С ЭФФЕКТОМ ПРИ СКРОЛЛЕ
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.site-header');

  if (header) {
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    handleScroll();
  }
});

// ============================================================
// ПЛАВНАЯ ПРОКРУТКА К ЯКОРЯМ С УЧЕТОМ ВЫСОТЫ ШАПКИ
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');

      if (targetId === '#') return;

      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        e.preventDefault();

        const header = document.querySelector('.site-header');
        const headerHeight = header ? header.offsetHeight : 0;
        const offset = headerHeight + 20;

        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});
